export default {
  edit (aModel) {
    this.editRelation('contacts', aModel)
  },

  delete (aModel) {
    this.deleteRelation('contacts', aModel)
  }
}



// WEBPACK FOOTER //
// ./src/functions/contact.js